import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskEnrollmentLayout.styles';
import {
  KioskFooter,
  KioskHeader,
  KioskEnrollmentMain,
  KioskIdelScreen
} from '..';

export class KioskEnrollmentLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle: 'Enrollment'
  };

  render() {
    const { classes } = this.props;
    var customFooterBottom;
    if (window.screen.width >= 1440) {
      customFooterBottom = '-25%';
    } else {
      customFooterBottom = '0%';
    }

    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <KioskEnrollmentMain />
        <KioskFooter customFooterBottom={customFooterBottom} />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskEnrollmentLayout);
